export default __webpack_public_path__ + "static/media/r4.2daef5a1.jpg";